import React, { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './ItemBooking.module.scss';
import { Row, Col, Divider, Modal } from 'antd';
import { getNumberWithCommas } from '~/utils';
import styled from 'styled-components';
import QRCodeModal from '../QRCodeModal';

import { useNavigate } from 'react-router-dom';
import { IMAGES } from '~/assets/assetsPath';

const cx = classNames.bind(styles);

const Item = styled.div`
    .ant-divider-horizontal {
        margin: 14px 0px;
    }
`;

const ItemBooking = ({ item }) => {
    const navigate = useNavigate();
    const [isShowQRCodeModal, setIsShowQRCodeModal] = useState(false);

    const handleShowQRCodeModal = () => {
        setIsShowQRCodeModal(true);
    };

    return (
        <Item>
            <div className={cx('container')}>
                <Row align="middle">
                    <Col xs={12}>
                        <Row align="middle">
                            Booking code:<span className={cx('code_service')}>#{item.booking_code}</span>
                        </Row>
                    </Col>
                    <Col xs={12}>
                        <Row justify="end" align="middle">
                            {item?.activity === 'WAITING' && <span className={cx('status')}>Waiting for confirmation</span>}
                            {item?.activity === 'PROCESSING' && <span className={cx('status')}>Confirmed</span>}
                            {(item?.activity === 'ASSIGNED' || item?.activity === 'CONFIRMED') && (
                                <span className={cx('status')}>Processing</span>
                            )}

                            {item?.activity === 'COMPLETED' && <span className={cx('status')}>Completed</span>}
                            {item?.activity === 'CANCELED' && <span className={cx('status')}>Canceled</span>}
                        </Row>
                    </Col>
                </Row>

                <Divider style={{ borderTop: '2px solid rgba(0,0,0,0.06)' }} />
                {item?.booking_details?.length
                    ? item.booking_details?.map((service, index) => {
                        return (
                            <>
                                <Row
                                    className={cx('service')}
                                    key={index}
                                    onClick={() => navigate(`/dich-vu-chi-tiet/${service.service.id}`)}
                                >
                                    <Col xs={6} xl={5}>
                                        <Row className={cx('image')}>
                                            <img src={service.image || IMAGES.ImagePlaceholder} alt="" />
                                        </Row>
                                    </Col>
                                    <Col xs={18} xl={19} className={cx('content')}>
                                        <div>
                                            <Row className={cx('name')}>{service.title}</Row>
                                            <Row className={cx('type')}>
                                                Service:  <span>{service.category_name}</span>
                                            </Row>
                                            <Row className={cx('time')}>
                                                Time:  <span>{service.execution_time} minutes</span>
                                            </Row>
                                            <Row className={cx('type')}>x{service.count}</Row>
                                        </div>
                                    </Col>
                                    <Col xs={24}>
                                        <Row className={cx('right_content')}>
                                            {service?.combo_service_id ? (
                                                <div className={cx('tag_combo_service')}>
                                                    {service?.combo_service?.title}
                                                </div>
                                            ) : (
                                                <>
                                                    {parseInt(service.discount) ? (
                                                        <div className={cx('old_price')}>
                                                            <del>
                                                                {getNumberWithCommas(service.price)}&nbsp;
                                                                {service?.service?.unit_id
                                                                    ? `d/${service?.service?.unit?.value}`
                                                                    : 'd'}
                                                            </del>
                                                        </div>
                                                    ) : null}
                                                    <div className={cx('new_price')}>
                                                        {getNumberWithCommas(service.price - service.discount)}&nbsp;
                                                        {service?.service?.unit_id
                                                            ? `d/${service?.service?.unit?.value}`
                                                            : 'd'}
                                                    </div>
                                                </>
                                            )}
                                        </Row>
                                    </Col>
                                </Row>
                                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                            </>
                        );
                    })
                    : null}
                {Number(item?.discount) ? (
                    <Row className={cx('total_price')}>
                        <Col xs={12}>
                            <Row className={cx('title')}>Reduced:</Row>
                        </Col>
                        <Col xs={12}>
                            <Row justify="end" className={cx('price')}>
                                - {getNumberWithCommas(item.discount)} d
                            </Row>
                        </Col>
                    </Row>
                ) : null}

                <Row className={cx('total_price')}>
                    <Col xs={12}>
                        <Row className={cx('title')}>Total amount:</Row>
                    </Col>
                    <Col xs={12}>
                        <Row justify="end" className={cx('price')}>
                            {getNumberWithCommas(item.total_price)} d
                        </Row>
                    </Col>
                </Row>
                {item?.branch ? (
                    <Row className={cx('payment_type')}>
                        <span>{item?.branch?.name}</span>
                    </Row>
                ) : null}

                <Row className={cx('payment_type')}>
                    {item.booking_type === 'CASH' && <span>Cash payment</span>}
                    {item.booking_type === 'CARD' && <span>Pay by card</span>}
                    {item.booking_type === 'WALLET' && <span>Pay with service limit wallet</span>}
                    {item.booking_type === 'TRANSFER' && <span>Pay by transfer</span>}
                </Row>

                <Row className={cx('footer')} align="middle">
                    <Col xs={8}>
                        <Row className={cx('noti')}>
                            {item.activity === 'WAITING' && (
                                <>Please check the service information before Beauty-ms receives it</>
                            )}
                            {(item.activity === 'ASSIGNED' ||
                                item.activity === 'PROCESSING' ||
                                item.activity === 'CONFIRMED') && (
                                    <>Beauty-ms has accepted your service and is arranging staff for you!</>
                                )}
                            {item.activity === 'COMPLETED' && (
                                <>
                                    Are you satisfied with the service Beauty-ms brings you? Please rate us
                                    Know how to fix it!
                                </>
                            )}
                            {item.activity === 'CANCELED' && <>You have canceled</>}
                        </Row>
                    </Col>
                    <Col xs={16}>
                        {/* <Row className={cx('payment_type')} justify="end">
                            {item.booking_type === 'CASH' && <span>Cash payment</span>}
                            {item.booking_type === 'CARD' && <span>Pay by card</span>}
                            {item.booking_type === 'WALLET' && <span>Pay with service limit wallet</span>}
                            {item.booking_type === 'TRANSFER' && <span>Pay by transfer</span>}
                        </Row> */}
                        <Row justify="end">
                            <div className={cx('btn', 'detail')} onClick={() => navigate(`/lich-dat/${item.id}`)}>
                                Detail
                            </div>

                            <div className={cx('btn', 'cancel')} onClick={handleShowQRCodeModal}>
                                QR code
                            </div>
                        </Row>
                    </Col>
                </Row>
            </div>
            <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
            {isShowQRCodeModal && (
                <Modal
                    centered
                    visible={isShowQRCodeModal}
                    closable={false}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <QRCodeModal setIsShowQRCodeModal={setIsShowQRCodeModal} item={item} />
                </Modal>
            )}
        </Item>
    );
};

export default ItemBooking;
